var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElcompathIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248,
    height: 60,
    viewBox: "0 0 248 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_6868",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 6868",
    transform: "translate(0.17 0.543)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1293",
    "data-name": "\\u9577\\u65B9\\u5F62 1293",
    width: 248,
    height: 60,
    transform: "translate(-0.17 -0.543)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2766",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2766",
    transform: "translate(12.057 12.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4253",
    "data-name": "\\u30D1\\u30B9 4253",
    d: "M440.619,152.382a11.956,11.956,0,1,0,8.4,20.462l-4.043-4.043A6.237,6.237,0,1,1,446.4,162h-8.445v4.67h14.388a11.951,11.951,0,0,0-11.725-14.291Z",
    transform: "translate(-428.662 -145.444)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2636",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2636",
    transform: "translate(38.19 6.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4254",
    "data-name": "\\u30D1\\u30B9 4254",
    d: "M618.328,170.577a6.238,6.238,0,1,1,4.355-10.7l4.044-4.043a11.957,11.957,0,1,0,0,17.012l-4.044-4.043A6.215,6.215,0,0,1,618.328,170.577Z",
    transform: "translate(-606.372 -152.382)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1284",
    "data-name": "\\u9577\\u65B9\\u5F62 1284",
    width: 5.718,
    height: 30.23,
    transform: "translate(28.198 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4255",
    "data-name": "\\u30D1\\u30B9 4255",
    d: "M1298.135,127.658h-3.84V120.1h-5.718v7.558h-3.841v5.147h3.841V150.33h5.718V132.806h3.84Z",
    transform: "translate(-1100.764 -120.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4256",
    "data-name": "\\u30D1\\u30B9 4256",
    d: "M1037.651,152.382a11.956,11.956,0,0,0-11.956,11.956v18.894h5.718v-8.708a11.951,11.951,0,1,0,6.238-22.142Zm0,18.195a6.238,6.238,0,1,1,6.239-6.238A6.238,6.238,0,0,1,1037.651,170.577Z",
    transform: "translate(-897.391 -145.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4257",
    "data-name": "\\u30D1\\u30B9 4257",
    d: "M1168.812,152.382a11.957,11.957,0,1,0,6.239,22.142v1.15h5.719V164.338A11.957,11.957,0,0,0,1168.812,152.382Zm0,18.195a6.238,6.238,0,1,1,6.239-6.238A6.238,6.238,0,0,1,1168.812,170.577Z",
    transform: "translate(-1000.366 -145.445)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2637",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2637",
    transform: "translate(89.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4258",
    "data-name": "\\u30D1\\u30B9 4258",
    d: "M869.528,152.382a9.816,9.816,0,0,0-6.99,2.913,9.848,9.848,0,0,0-16.839,6.936h0v13.443h5.718V162.231h0a4.131,4.131,0,1,1,8.262,0h0v13.443H865.4V162.231h0a4.131,4.131,0,0,1,8.263,0h0v13.443h5.718V162.231A9.849,9.849,0,0,0,869.528,152.382Z",
    transform: "translate(-845.697 -145.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4259",
    "data-name": "\\u30D1\\u30B9 4259",
    d: "M1380.211,127.037a9.8,9.8,0,0,0-4.133.918V120.1h-5.718v30.23h5.718V136.887h0a4.131,4.131,0,1,1,8.262,0h0V150.33h5.718V136.887h0A9.85,9.85,0,0,0,1380.211,127.037Z",
    transform: "translate(-1257.609 -120.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2638",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2638",
    transform: "translate(61.412 6.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4260",
    "data-name": "\\u30D1\\u30B9 4260",
    d: "M720.148,164.338a6.239,6.239,0,0,1,6.239-6.238v-5.718A11.938,11.938,0,0,0,716.2,170.577h-.015l10.2,16v-16A6.239,6.239,0,0,1,720.148,164.338Z",
    transform: "translate(-714.43 -152.382)",
    fill: "#ceaf59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2639",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2639",
    transform: "translate(73.369 6.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4261",
    "data-name": "\\u30D1\\u30B9 4261",
    d: "M776.306,164.338a6.239,6.239,0,0,0-6.239-6.238v-5.718a11.938,11.938,0,0,1,10.185,18.195h.015l-10.2,16v-16A6.239,6.239,0,0,0,776.306,164.338Z",
    transform: "translate(-770.067 -152.382)",
    fill: "#b9394e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElcompathIcon);
export default __webpack_public_path__ + "static/media/elcompath_icon.2408b520cde0e3944d0b8d1a9a387b82.svg";
export { ForwardRef as ReactComponent };